import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { STAFF_HOSTNAMES } from './config';

// /privacy on any hostname: the privacy policy. Staff app (formerly hkccapp.com) on /staff, or on any
// path of a staff hostname such as hkccapp.com; otherwise the appointment chatbot (formerly
// appointmentapp, served at apt.hkccapp.com).
// Each app is lazy-loaded so its global CSS is only applied on its own route.
const path = window.location.pathname;
const isStaff = path.startsWith('/staff') || STAFF_HOSTNAMES.includes(window.location.hostname);
const App = path.startsWith('/privacy')
  ? lazy(() => import('./privacy/PrivacyPolicy'))
  : isStaff
    ? lazy(() => import('./staff/App'))
    : lazy(() => import('./booking/App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
